export const handleLabel = (params) => {
    try {
      return <span>{params}<span style={{ color: 'red' }}>*</span></span>
    }
    catch (e) {
      console.log(e);
    }
  }